import React, { Component } from "react";
import NewImageButton from "../2/Controls/NewImageButton";
import ExportButton from "../2/Controls/ExportButton";
import Window from "../2/Controls/Window";
import { isMobileApp } from "../../actions/Util";
import Icon from "../2/Controls/Icon";
import NewButton from "../2/Controls/NewButton";
import Button from "../2/Controls/Button";

class ReportViewPage extends Component {
  constructor(props) {
    super(props);
    this.dropdownRef = React.createRef();
    this.state = {
      showFilterDrawer: false,
      updatedFilter: props.filters || []
    };
  }

  componentDidMount() {
    console.log("this.props", this.props);
    document.addEventListener("mousedown", this.handleClickOutside);

    if (this.props.filters && this.props.filters.length > 0) {
      this.setState({ updatedFilter: this.props.filters });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    console.log("componentdidiupdate", this.props);

    const filtersChanged = JSON.stringify(prevProps.filters) !== JSON.stringify(this.props.filters);

    if (filtersChanged) {
      console.log("Filters updated in ReportViewPage", this.props.filters);
      this.setState({ updatedFilter: this.props.filters });
    }
  }

  handleClickOutside = (event) => {
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
      this.setState({ showFilterDrawer: false });
    }
  };

  handleApply = () => {
    if (this.props.onApplyFilters && typeof this.props.onApplyFilters === 'function') {
      this.props.onApplyFilters();
    }
    this.setState({ showFilterDrawer: false });
  };

  handleClear = () => {
    if (this.props.onRefresh && typeof this.props.onRefresh === 'function') {
      this.props.onRefresh();
    }
    this.setState({ showFilterDrawer: false });
  };

  handleRemoveClick = () => {
    if (this.props.handleRemoveBtnClick && typeof this.props.handleRemoveBtnClick === 'function') {
      this.props.handleRemoveBtnClick();
    } else {
      window.history.back();
    }
  };

  handleExport = (value) => {
    const { onExport } = this.props;
    if (onExport && typeof onExport === 'function') {
      onExport(value);
    }
  };

  handleFilterDrawerClose = () => {
    this.setState({ showFilterDrawer: false });
  };

  handleWindowButtonClick = (label) => {
    if (label === "Search") {
      this.handleApply();
    } else if (label === "Clear") {
      this.handleClear();
    }
  };

  render() {
    const {
      exportLoading,
      reportConfig,
      subText,
      filters,
      footer = null,
      children,
      onRefresh,
      onApplyFilters,
      hideFooter,
      title,
      hideApplyFilterButton,
      loading,
      isInStock,
      inStockTotal,
      onExport
    } = this.props;

    console.log("hideFotter",hideFooter);
    const { showFilterDrawer, updatedFilter } = this.state;

    // Helper function to safely access nested properties
    const hasProp = (obj, prop) => {
      return obj && Object.prototype.hasOwnProperty.call(obj, prop);
    };

    // Get report config title safely
    const reportTitle = (reportConfig && hasProp(reportConfig, 'title')) ? reportConfig.title : null;
    const finalTitle = reportTitle || title;

    // Get stock values safely
    const totalSales = (inStockTotal && hasProp(inStockTotal, 'totalsales')) ? inStockTotal.totalsales : 0;
    const totalPurchase = (inStockTotal && hasProp(inStockTotal, 'totalpurchase')) ? inStockTotal.totalpurchase : 0;
    const totalQty = (inStockTotal && hasProp(inStockTotal, 'totalqty')) ? inStockTotal.totalqty : 0;

    // Check if stock has any valid data
    const hasStockData = isInStock && inStockTotal && (
      (hasProp(inStockTotal, 'totalsales') && inStockTotal.totalsales) ||
      (hasProp(inStockTotal, 'totalpurchase') && inStockTotal.totalpurchase) ||
      (hasProp(inStockTotal, 'totalqty') && inStockTotal.totalqty)
    );

    // Common styles
    const styles = {
      // Main container
      mainContainer: {
        backgroundColor: "#f3f4f6",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden"
      },
      // Header wrapper
      headerWrapper: {
        flex: "none",
        paddingLeft: "0.75rem",
        paddingRight: "0.75rem",
        paddingTop: "0.75rem"
      },
      // Relative container for z-index
      relativeContainer: {
        position: "relative",
        zIndex: 10
      },
      // Header card
      headerCard: {
        backgroundColor: "rgba(255, 255, 255, 0.6)",
        border: "1px solid #e5e7eb",
        padding: "1rem",
        position: "relative",
         borderTopLeftRadius: "0.75rem",
  borderTopRightRadius: "0.75rem"
      },
      // Top row container - flex between title and desktop actions
      topRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: "1.25rem"
      },
      // Left title area
      leftTitleArea: {
        flex: 1,
        minWidth: 0
      },
      // Title row with flex between title and mobile actions
      titleRow: {
        display: "flex",
        justifyContent: "space-between",
       alignItems: "center",
        
        width: "100%"
      },
      // Title wrapper with icon
      titleWrapper: {
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "0.5rem"
      },
      titleText: {
        fontSize: "21px",
        fontWeight: "bold",
        color: "#1f2937",
        margin: 0,
        padding: 0,
        lineHeight: 1.2
      },
  
      // Mobile actions container
      mobileActions: {
        display: "flex",
        alignItems: "center",
        gap: "0.5rem"
      },
      // Subtext style
      subTextStyle: {
        color: "#6b7280",
        marginTop: "0.25rem",
        marginLeft: "2.875rem",
        marginBottom: 0
      },
      // Desktop actions container
      desktopActions: {
        display: "flex",
        flexDirection: "column",
        gap: "1.25rem"
      },
      desktopFlexRow: {
        display: "flex",
        gap: "1.25rem",
        alignItems: "center",
        justifyContent: "flex-end"
      },
      removeIconDesktop: {
        width: "1.75rem",
        padding: 0,
        textAlign: "right",
        color: "#6b7280",
        cursor: "pointer",
        marginTop: "0.375rem"
      },
      removeIconMobile: {
        width: "1.75rem",
        padding: 0,
        textAlign: "right",
        color: "#6b7280",
        cursor: "pointer"
      },
      // Filters grid
      filtersGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(6, minmax(0, 1fr))",
        gap: "5px",
        marginTop: "1.25rem"
      },
      buttonContainer: {
        display: "flex",
        marginTop: "1.75rem"
      },
      // Stock info container
      stockContainer: {
        padding: "0.5rem 1.25rem",
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: "2rem",
        alignItems: "center",
        marginTop: "0.5rem"
      },
      stockText: {
        color: "var(--list-item-gray)",
        margin: 0,
        fontSize: "1rem",
        fontWeight: "normal"
      },
      stockSpan: {
        fontWeight: "600"
      },
      // Main content
      mainContent: {
        flexGrow: 1,
        paddingLeft: "0.75rem",
        paddingRight: "0.75rem",
        overflow: "hidden"
      },
      // Footer
 footerContainer: {
  flex: "none",
  paddingLeft: "0.75rem",
  paddingRight: "0.75rem",
  marginBottom: "0.75rem",
    borderRadius: "0 0 0.75rem 0.75rem",
},
      footerContent: {
        // backgroundColor: "rgba(255, 255, 255, 0.7)",
        // borderRadius: "0.75rem",
        // border: "1px solid #e5e7eb"
      }
    };

    // Responsive styles using media queries
    const responsiveStyles = `
      @media (max-width: 1023px) {
        .desktop-actions { display: none !important; }
        .filters-grid { display: none !important; }
        .stock-row { flex-direction: column !important; align-items: flex-start !important; gap: 0.5rem !important; }
        .stock-container { flex-direction: column !important; align-items: flex-start !important; gap: 0.5rem !important; padding-left: 0 !important; }
      }
      @media (min-width: 1024px) {
        .desktop-actions { display: block !important; }
        .mobile-actions { display: none !important; }
        .filters-grid { display: grid !important; }
        .top-row { flex-direction: row !important; align-items: flex-start !important; }
        .stock-row { flex-direction: row !important; align-items: center !important; gap: 2rem !important; }
        .stock-container { flex-direction: row !important; align-items: center !important; gap: 2rem !important; }
      }
    `;

    return (
      <div className="header-margin report-view-page">
        <style>{responsiveStyles}</style>
        <div style={styles.mainContainer}>
          {/* Header */}
          <div style={styles.headerWrapper}>
            <div style={styles.relativeContainer}>
              <div style={styles.headerCard}>
                {/* Top row: title and desktop actions */}
                <div className="top-row" style={styles.topRow}>
                  {/* Left side - Title */}
                  <div style={styles.leftTitleArea}>
                    <div style={styles.titleRow}>
                      <div style={styles.titleWrapper}>
                       
                     <div style={{ flex: 1, textAlign: "center" }}>
  <h1 style={styles.titleText}>{finalTitle}</h1>
</div>
                      </div>

                      {/* Mobile Actions */}
                      <div className="mobile-actions" style={styles.mobileActions}>
                            <NewImageButton
                          icon="refresh"
                            onClick={onRefresh}
                          label="refresh"
                        />

                           <NewImageButton
                          icon="filter"
                          onClick={() => {
                            this.setState({ showFilterDrawer: true });
                          }}
                          label="filter"
                        />
                     
                      
                        <span
                          style={styles.removeIconMobile}
                          onClick={this.handleRemoveClick}
                        >
                          <Icon type={"remove"} />
                        </span>
                      </div>
                    </div>

                  
                  </div>

                  {/* Desktop Actions */}
                  <div className="desktop-actions" style={styles.desktopActions}>
                    <div style={styles.desktopFlexRow}>
                      {!isMobileApp() && (
                        <ExportButton
                          label="Download"
                          onExport={this.handleExport}
                          loading={exportLoading}
                        />
                      )}

                         <NewImageButton
                          icon="refresh"
                            onClick={onRefresh}
                          label="refresh"
                        />
                          


                      <span
                        style={styles.removeIconDesktop}
                        onClick={this.handleRemoveClick}
                      >
                        <Icon type={"remove"} />
                      </span>
                    </div>
                  </div>
                </div>

                {/* Filters section */}
                <div className="filters-grid" style={styles.filtersGrid}>
                  {updatedFilter}
                  {!hideApplyFilterButton && (
                    <div style={styles.buttonContainer}>
                      <NewButton
                        text="Apply Filter"
                        type="primary"
                        onClick={onApplyFilters}
                        processing={loading}
                      />
                    </div>
                  )}
                </div>

                {/* Stock Info */}
                {hasStockData && (
                  <div className="stock-container" style={styles.stockContainer}>
                    {totalSales && (
                      <h1 style={styles.stockText}>
                        Total Sales: <span style={styles.stockSpan}>{totalSales}</span>
                      </h1>
                    )}
                    {totalPurchase && (
                      <h1 style={styles.stockText}>
                        Total Purchase: <span style={styles.stockSpan}>{totalPurchase}</span>
                      </h1>
                    )}
                    {totalQty && (
                      <h1 style={styles.stockText}>
                        Total Quantity: <span style={styles.stockSpan}>{totalQty}</span>
                      </h1>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div style={styles.mainContent}>
            {children}
          </div>

          {/* Footer */}
          {!isMobileApp() && (
            <div style={styles.footerContainer}>
              {!hideFooter && (
                <div style={styles.footerContent}>
                  {footer}
                </div>
              )}
            </div>
          )}
        </div>

        {/* Filter Window */}
        {showFilterDrawer && (
          <Window
            slide={true}
            header="Filters"
            onClose={this.handleFilterDrawerClose}
            buttons={[
              { Text: "Clear", Type: "secondary", Align: "left" },
              { Text: "Search", Type: "primary", Align: "right" },
            ]}
            onButtonClick={this.handleWindowButtonClick}
            size="small"
            overflowHidden={false}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
                gap: "0.75rem"
              }}
            >
              <div style={{ margin: "0 auto", width: "100%" }}>
                <ExportButton
                  onExport={this.handleExport}
                  loading={loading}
                />
              </div>
              {updatedFilter}
            </div>
          </Window>
        )}
      </div>
    );
  }
}

export default ReportViewPage;